import http from "../http";

export default (axios, base) => ({
  list: (page = 1, pageSize = 15) => http.get(`${base}?page=${page}&per_page=${pageSize}`),
  update: (id, data)  => http.put(`${base}/${id}`, data)
});